export const MAX_VAULT_FILE_SIZE_MB = 100;
export const SUPPORTED_FILE_FORMATS = ['.pdf', '.csv', '.xls', '.xlsx', '.doc', '.docx', '.ppt', '.pptx', '.jpg', '.jpeg', '.png', '.xlsm'];
export const SUPPORTED_FILE_FORMATS_MAP = {
    '.pdf': 'application/pdf',
    '.csv': 'text/csv',
    '.xls': 'application/vnd.ms-excel',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.ppt': 'application/vnd.ms-powerpoint',
    '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
};
export const VAULT_SECURE_TAG_TEXT = 'We use bank-grade security and advanced encryption technologies to protect data privacy and security. All submitted documents are anonymized and then analyzed either by our LLM or, when needed, by our in-house team of analysts. Your data is never used to train our LLM model.';